import { render, staticRenderFns } from "./purchase-stock-item-price-list.vue?vue&type=template&id=48fc34d4&"
import script from "./purchase-stock-item-price-list.vue?vue&type=script&lang=js&"
export * from "./purchase-stock-item-price-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
